var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',{attrs:{"title":_vm.pageTitle,"config":{
    needsActivedRewards: true,
    needsActivedBilling: true,
    isEmptyState: false
  }}},[(!_vm.newRefundPolicyPageIsActive)?_c('RefundPolicyPageV1'):_c('RefundPolicyPageV2')],1)}
var staticRenderFns = []

export { render, staticRenderFns }